export const generatorHelpKey = {entity: 'NETFORM', key: 5};
export const fatalSessionMsg = {entity: 'NETFORM', key: 4};
